import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createContext, useState, useCallback, useMemo, useContext, useEffect } from "react";
import classnames from "classnames";
import styles from "@/styles/Notification.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NotificationContext = /*#__PURE__*/createContext({
  showNotification: function showNotification() {
    return null;
  },
  hideNotification: function hideNotification() {
    return null;
  }
});
var initialValue = {
  message: null,
  props: {}
};
export function NotificationProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(initialValue),
      notification = _useState[0],
      setNotification = _useState[1];

  var showNotification = useCallback(function (message) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setNotification({
      message: message,
      props: props
    });
  }, []);
  var hideNotification = useCallback(function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setNotification(_objectSpread(_objectSpread({}, initialValue), {}, {
      props: props
    }));
  });
  var contextValue = useMemo(function () {
    return {
      showNotification: showNotification,
      hideNotification: hideNotification
    };
  }, []);
  return /*#__PURE__*/_jsxs(NotificationContext.Provider, {
    value: contextValue,
    children: [children, /*#__PURE__*/_jsx(Notification, _objectSpread({
      message: notification.message
    }, notification.props))]
  });
}
export default function Notification(_ref2) {
  var _classnames;

  var message = _ref2.message,
      _ref2$time = _ref2.time,
      time = _ref2$time === void 0 ? 5000 : _ref2$time,
      caution = _ref2.caution,
      fixed = _ref2.fixed;

  var _useContext = useContext(NotificationContext),
      hideNotification = _useContext.hideNotification;

  var handleClick = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  useEffect(function () {
    var hideTimeoutId;

    if (message && !fixed) {
      hideTimeoutId = setTimeout(function () {
        hideNotification();
      }, time);
    }

    return function () {
      clearTimeout(hideTimeoutId);
    };
  }, [message]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.notification, (_classnames = {}, _defineProperty(_classnames, styles.show, !!message), _defineProperty(_classnames, styles.caution, caution), _classnames)),
    children: message && /*#__PURE__*/_jsx("div", {
      className: styles.inner,
      onClick: handleClick,
      children: message
    })
  });
}